export const defaultWorkEndTime = '16:00';
